import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import MuiCheckbox from '@material-ui/core/Checkbox';
import { withStyles, useDensity } from '@jpmuitk/theme';
import checkboxIcon from './assets/checkboxIcon';
import checkboxCheckedIcon from './assets/checkboxCheckedIcon';
import checkboxIndeterminateIcon from './assets/checkboxIndeterminateIcon';
import { CheckboxBaseStyle } from './style';
export var CheckboxBase = /*#__PURE__*/forwardRef(function CheckboxBase(_ref, ref) {
  var checked = _ref.checked,
      className = _ref.className,
      classes = _ref.classes,
      indeterminate = _ref.indeterminate,
      densityProp = _ref.density,
      inputProps = _ref.inputProps,
      rest = _objectWithoutProperties(_ref, ["checked", "className", "classes", "indeterminate", "density", "inputProps"]);

  var checkedIcon = checkboxCheckedIcon(classes);
  var density = useDensity(densityProp);
  var uncheckedIcon = checkboxIcon(classes);
  var indeterminateIcon = checkboxIndeterminateIcon(classes);

  var finalInputProps = _assign({
    'aria-checked': indeterminate ? 'mixed' : checked
  }, inputProps);

  return /*#__PURE__*/React.createElement(MuiCheckbox, _assign({
    checked: checked,
    checkedIcon: checkedIcon,
    className: classnames(className, _defineProperty({}, classes.indeterminate, indeterminate), classes["".concat(density, "Density")]),
    classes: {
      root: classes.iconRoot,
      checked: classes.checked,
      disabled: classes.disabled
    },
    disableRipple: true,
    focusVisibleClassName: classes.focusVisible,
    icon: uncheckedIcon,
    indeterminate: indeterminate,
    indeterminateIcon: indeterminateIcon,
    inputProps: finalInputProps,
    ref: ref
  }, rest));
});
process.env.NODE_ENV !== "production" ? CheckboxBase.propTypes = {
  /**
   * @external - material-ui
   * If `true`, the component is checked
   */
  checked: PropTypes.bool,

  /**
   * The className(s) of the component
   */
  className: PropTypes.string,

  /**
   * Class selectors required by theme
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * The density of a component affects the style of the layout.
   * A high density component uses minimal sizing and spacing to convey the intended UI design.
   * Conversely, a low density component, maximizes the use of space and size to convey the UI Design.
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * @external - material-ui
   * If `true`, the box will be disabled.
   */
  disabled: PropTypes.bool,

  /*
   * @external - material-ui
   * If true, the component appears indeterminate. This does not set the native
   * input element to indeterminate due to inconsistent behavior across browsers.
   * However, a data-indeterminate attribute is set on the input.
   */
  indeterminate: PropTypes.bool,

  /*
   * @external - material-ui
   * Properties applied to the input element.
   */
  inputProps: PropTypes.objectOf(PropTypes.any),

  /**
   * @external - material-ui
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the checkbox
   */
  onChange: PropTypes.func,

  /**
   * @external - material-ui
   * The value of the checkbox
   */
  value: PropTypes.string
} : void 0; // TODO (BREAKING CHANGE REQUIRED)
// https://issuetracking.jpmchase.net/jira12/browse/JPMUITK-2835
// Add unique JPMUI prefix to name to identify component as a Toolkit component

export default withStyles(CheckboxBaseStyle, {
  name: 'CheckboxBase'
})(CheckboxBase);